import { observable, computed, autorun, action, makeObservable } from "mobx";
import { chartColors } from "../../shared/DiscretesAndTrends/TrendChart";
import {
  getDiscretes,
  getVentConfig,
  getVentSettings,
  getLabs,
  getVentTrends,
} from "../../serviceCalls";
import config from "../../config";
import * as _ from "lodash";

export default class VentilatorStore {
  discreteGroups = [];
  trends = undefined;
  discretes = [];
  settings = undefined;
  labs = undefined;
  charts = [];
  loadingLabs;
  loadingDiscretes;
  activeTrends = {};
  loading = false;
  error = "";

  maxChartWidth = 0;

  constructor({ asmpid }) {
    makeObservable(this, {
      discreteGroups: observable,
      trends: observable,
      discretes: observable,
      settings: observable,
      labs: observable,
      charts: observable,
      loadingLabs: observable,
      loadingDiscretes: observable,
      activeTrends: observable,
      loading: observable,
      error: observable,
      maxChartWidth: observable,
      fetchVentConfig: action,
      fetchDiscretes: action,
      fetchLabs: action,
      fetchSettings: action,
      activeCharts: computed,
      labGroups: computed,
    });

    this.asmpid = asmpid;
    this.fetchVentConfig();
    this.fetchDiscretes();
    this.fetchSettings();
    if (config.emr) {
      this.fetchLabs();
    }

    autorun(() => {
      this.charts = this.discreteGroups.map((group, i) => ({
        ...group,
        active: false,
        trend: { ...group.trend },
        values: group.keys.map((key) => {
          return (
            this.discretes
              ? this.discretes.find((discrete) => discrete.key === key) || {}
              : {}
          ).data;
        }),
        color: chartColors[i % chartColors.length],
      }));
    });
  }

  dispose() {
    this.fetchDiscretes = _.noop();
    clearTimeout(this.discreteTimeout);
  }

  async fetchVentConfig() {
    this.discreteGroups = await getVentConfig(this.asmpid).then(
      (model) => model.discreteGroups,
    );
  }

  fetchDiscretes() {
    if (!this.discretes.length) {
      this.loadingDiscretes = true;
    }
    getDiscretes(this.asmpid, { quiet: !!this.discretes.length })
      .then(
        (model) => (this.discretes = _.get(model, "data[0].discreteData", [])),
      )
      .then(
        () =>
          (this.discreteTimeout = setTimeout(
            () => this.fetchDiscretes && this.fetchDiscretes(),
            5000,
          )),
      )
      .finally(() => (this.loadingDiscretes = false));
  }

  async fetchLabs() {
    this.loadingLabs = true;
    this.labs = await getLabs({
      asmpid: this.asmpid,
      type: "vent",
    });
    this.labs.groups.forEach((group) => {
      const drawIndex = _.findIndex(group.items, { title: "DRAWN" });
      if (drawIndex !== -1) {
        group.items = [
          group.items[drawIndex],
          ...group.items.slice(0, drawIndex),
          ...group.items.slice(drawIndex + 1, group.items.length),
        ];
      }
    });
    this.loadingLabs = false;
  }

  async fetchSettings() {
    this.settings = await getVentSettings(this.asmpid);
  }

  fetchTrend(key) {
    return getVentTrends({
      asmpid: this.asmpid,
      keys: key,
    }).then((model) => {
      return model.trends;
    });
  }

  get activeCharts() {
    return this.charts
      .filter((chart) => chart.active)
      .map((chart) => {
        return chart;
      });
  }
  get labGroups() {
    return {
      groups: (this.settings ? this.settings.groups : []).concat(
        this.labs ? this.labs.groups : [],
      ),
    };
  }
}
